import { render, staticRenderFns } from "./f1fbaa8f-217a-4357-b7d7-9401f3bbf875.vue?vue&type=template&id=567bfa96&scoped=true&"
import script from "./f1fbaa8f-217a-4357-b7d7-9401f3bbf875.vue?vue&type=script&lang=js&"
export * from "./f1fbaa8f-217a-4357-b7d7-9401f3bbf875.vue?vue&type=script&lang=js&"
import style0 from "./f1fbaa8f-217a-4357-b7d7-9401f3bbf875.vue?vue&type=style&index=0&id=567bfa96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bfa96",
  null
  
)

export default component.exports